export default __webpack_public_path__ + "static/media/b83d27de-2935-4007-9989-a88348aadec8.30786990.jpeg";